export const sentimentsCount = sentiments => sentiments.reduce((acc, { value }) => acc + value, 0);
export const intentsCount = intents => intents.reduce((acc, { value }) => acc + value, 0);
